(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rescue-store"] && !Shopify.designMode) return;
  try {
    
function rescueStickyState(){const hero=document.getElementById('producto');if(hero)document.body.classList.toggle('r-past-product',hero.getBoundingClientRect().bottom<100);}document.addEventListener('scroll',rescueStickyState,{passive:true});document.addEventListener('DOMContentLoaded',rescueStickyState);


document.addEventListener('click',function(e){const btn=e.target.closest('[data-gallery-step],[data-gallery-index]');if(!btn)return;const root=btn.closest('[data-gallery]');const track=root.querySelector('.r-gallery-track');const w=track.clientWidth;const index=btn.hasAttribute('data-gallery-index')?Number(btn.dataset.galleryIndex):Math.round(track.scrollLeft/w)+Number(btn.dataset.galleryStep);track.scrollTo({left:Math.max(0,index)*w,behavior:'smooth'});});
function rescueGalleryDots(){document.querySelectorAll('[data-gallery]').forEach(function(root){const track=root.querySelector('.r-gallery-track');if(track.dataset.ready)return;track.dataset.ready='true';track.addEventListener('scroll',function(){const index=Math.round(track.scrollLeft/track.clientWidth);root.querySelectorAll('[data-gallery-index]').forEach(function(dot,i){dot.classList.toggle('is-active',i===index);dot.setAttribute('aria-current',String(i===index));});root.querySelectorAll('video').forEach(function(video){if(!video.paused)video.pause();});},{passive:true});});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',rescueGalleryDots);else rescueGalleryDots();document.addEventListener('shopify:section:load',rescueGalleryDots);


function rescueInitPlayers(root){
  root.querySelectorAll('.r-hero video,.r-story video,[data-video-carousel] video').forEach(function(video){
    if(video.closest('.r-player-shell'))return;
    video.removeAttribute('controls');
    video.setAttribute('playsinline','');
    video.setAttribute('disablepictureinpicture','');
    video.setAttribute('controlslist','nodownload nofullscreen noremoteplayback');
    video.muted=true;
    const shell=document.createElement('div');shell.className='r-player-shell';
    video.parentNode.insertBefore(shell,video);shell.appendChild(video);
    const button=document.createElement('button');button.type='button';button.className='r-player-toggle';button.setAttribute('aria-label','Reproducir vídeo');
    const icon=document.createElement('span');icon.className='r-player-symbol';icon.setAttribute('aria-hidden','true');icon.textContent='▶';button.appendChild(icon);shell.appendChild(button);
    const sync=function(){const playing=!video.paused&&!video.ended;shell.classList.toggle('is-playing',playing);button.setAttribute('aria-label',playing?'Pausar vídeo':'Reproducir vídeo');icon.textContent=playing?'Ⅱ':'▶';};
    button.addEventListener('click',function(){if(video.paused){video.play().catch(function(){sync();});}else{video.pause();}});
    video.addEventListener('play',function(){document.querySelectorAll('.r-player-shell video').forEach(function(other){if(other!==video)other.pause();});sync();});
    video.addEventListener('pause',sync);video.addEventListener('ended',sync);sync();
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){rescueInitPlayers(document);});}else{rescueInitPlayers(document);}
document.addEventListener('shopify:section:load',function(){rescueInitPlayers(document);});(function(){if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;var cn=navigator.connection;if(cn&&cn.saveData)return;var vis=new Map();var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)vis.set(e.target,e.intersectionRatio);else vis.delete(e.target);});var best=null,br=0;vis.forEach(function(r,v){if(r>br+0.01){br=r;best=v;}});document.querySelectorAll('[data-autoplay-ready]').forEach(function(v){if(v===best){if(v.paused&&!v.dataset.userPaused){v.muted=true;var p=v.play();if(p&&p.catch)p.catch(function(){});}}else if(!v.paused){v.pause();}});},{threshold:[0.6,0.8,1]});function watch(){document.querySelectorAll('.r-hero video,.r-story video,[data-video-carousel] video').forEach(function(v){if(v.dataset.autoplayReady)return;v.dataset.autoplayReady='1';v.muted=true;v.setAttribute('playsinline','');io.observe(v);});}document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('.r-player-toggle');if(b){var v=b.parentNode.querySelector('video');if(v)v.dataset.userPaused=v.paused?'':'1';}},true);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch);else watch();document.addEventListener('shopify:section:load',watch);})();

document.addEventListener('click',function(event){const trigger=event.target.closest('[data-video-dialog]');if(trigger){const dialog=document.getElementById(trigger.dataset.videoDialog);if(dialog)dialog.showModal();}});document.addEventListener('close',function(event){if(event.target.matches('.r-video-dialog'))event.target.querySelectorAll('video').forEach(function(video){video.pause();});},true);

document.addEventListener('click',function(event){const button=event.target.closest('[data-carousel-direction]');if(!button)return;const root=button.closest('[data-video-carousel]');const track=root.querySelector('.r-video-track');const slide=track.querySelector('.r-video-slide');if(slide)track.scrollBy({left:(slide.getBoundingClientRect().width+20)*Number(button.dataset.carouselDirection),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});
document.addEventListener('play',function(event){if(!event.target.matches('[data-video-carousel] video'))return;document.querySelectorAll('[data-video-carousel] video').forEach(function(video){if(video!==event.target)video.pause();});},true);

  } catch(e) { console.error(e); }
})();
})();
